/** Códigos de área (característica) de Argentina para números de celular, organizados por provincia/región. */
export interface AreaCodeArgentina {
  label: string;
  value: string;
}

export const AREA_CODES_ARGENTINA: AreaCodeArgentina[] = [
  { label: "+54 9 11 — CABA / GBA", value: "+54911" },
  { label: "+54 9 221 — La Plata", value: "+549221" },
  { label: "+54 9 223 — Mar del Plata", value: "+549223" },
  { label: "+54 9 249 — Tandil", value: "+549249" },
  { label: "+54 9 261 — Mendoza", value: "+549261" },
  { label: "+54 9 264 — San Juan", value: "+549264" },
  { label: "+54 9 266 — San Luis", value: "+549266" },
  { label: "+54 9 280 — Trelew / Comodoro", value: "+549280" },
  { label: "+54 9 291 — Bahía Blanca", value: "+549291" },
  { label: "+54 9 299 — Neuquén", value: "+549299" },
  { label: "+54 9 341 — Rosario", value: "+549341" },
  { label: "+54 9 342 — Santa Fe", value: "+549342" },
  { label: "+54 9 343 — Paraná", value: "+549343" },
  { label: "+54 9 351 — Córdoba", value: "+549351" },
  { label: "+54 9 358 — Río Cuarto", value: "+549358" },
  { label: "+54 9 362 — Resistencia", value: "+549362" },
  { label: "+54 9 364 — Sáenz Peña", value: "+549364" },
  { label: "+54 9 370 — Formosa", value: "+549370" },
  { label: "+54 9 376 — Posadas", value: "+549376" },
  { label: "+54 9 379 — Corrientes", value: "+549379" },
  { label: "+54 9 381 — Tucumán", value: "+549381" },
  { label: "+54 9 383 — Catamarca", value: "+549383" },
  { label: "+54 9 385 — Santiago del Estero", value: "+549385" },
  { label: "+54 9 387 — Salta", value: "+549387" },
  { label: "+54 9 388 — Jujuy", value: "+549388" },
];

export const DEFAULT_AREA_CODE_ARGENTINA = "+54911";

/** Sufijos (característica) de área válidos, para auto-avanzar al número. */
export const AREA_CODE_SUFFIXES = new Set(
  AREA_CODES_ARGENTINA.map((a) => a.value.replace("+54", "").replace(/^9/, ""))
);

/** True si el valor tipeado es una característica completa (auto-avanzar al número). */
export const esAreaCodeCompleto = (value: string): boolean => AREA_CODE_SUFFIXES.has(value);
